import { render, staticRenderFns } from "./LvStateDropdownRadioInputAvatar001.vue?vue&type=template&id=07516c88"
import script from "./LvStateDropdownRadioInputAvatar001.vue?vue&type=script&lang=js"
export * from "./LvStateDropdownRadioInputAvatar001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports